import { Snapshot } from '../shared/interfaces/snapshot';

export class BuyerCpiOverrideSnapShot implements Snapshot<number> {
  private _buyerCpiOverrideSnapshot: number = 0;
  private _snapshotExists: boolean = false;

  constructor(private _buyerCpiOverride: number) {}

  get() {
    return this._buyerCpiOverride;
  }
  update(value: number): void {
    this._buyerCpiOverride = value;
  }
  restore(): void {
    this._buyerCpiOverride = this._buyerCpiOverrideSnapshot;
  }
  take(): void {
    this._snapshotExists = true;
    this._buyerCpiOverrideSnapshot = this._buyerCpiOverride;
  }
  exists(): boolean {
    return this._snapshotExists;
  }
  equal(other: number): boolean {
    return this._buyerCpiOverrideSnapshot === other;
  }
}
